import { Injectable } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { SafeSrcPipe } from "../../pipes/safe-src.pipe";

// this should be imported only in app.component.ts

@Injectable({ providedIn: "root" })

/** Register svgs as mat-icons */
export class CustomIconRegistryService {
  constructor(private matIconRegistry: MatIconRegistry, private safeSrc: SafeSrcPipe) {
    this.registerSvgIcons();
  }

  private registerSvgIcons() {
    const icons: Array<{ name: string; path: string }> = [
      { name: "onsip_presence_away", path: "away.svg" },
      { name: "onsip_presence_busy", path: "busy.svg" },
      { name: "onsip_presence_available", path: "check.svg" },
      { name: "white_pencil_edit", path: "white_pencil_edit.svg" },
      { name: "black_pencil_edit", path: "black_pencil_edit.svg" },
      { name: "facebook_icon", path: "facebook_icon.svg" },
      { name: "linkedin_icon", path: "linkedin_icon.svg" },
      { name: "twitter_icon", path: "twitter_icon.svg" }
    ];

    icons.forEach(icon =>
      this.matIconRegistry.addSvgIcon(
        icon.name,
        this.safeSrc.transform(`resources/img/icons/${icon.path}`) as string
      )
    );
  }
}
